import axios from 'axios';

/** Extract a human-readable message from an axios/unknown error. */
export function errorMessage(err: unknown, fallback = 'Something went wrong'): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as
      | { message?: string | string[]; error?: string }
      | undefined;
    if (data?.message) {
      return Array.isArray(data.message) ? data.message.join(', ') : data.message;
    }
    if (data?.error) return data.error;
    return err.message || fallback;
  }
  if (err instanceof Error) return err.message;
  return fallback;
}
